export const OFFER_LEG_KEYS = [
  'payin',
  'payout',
  'settlement',
  'crypto_topup',
] as const;

export type OfferLegKey = (typeof OFFER_LEG_KEYS)[number];

export type OfferLegLabelKey =
  | 'pages.admin.offers.legs.payin'
  | 'pages.admin.offers.legs.payout'
  | 'pages.admin.offers.legs.settlement'
  | 'pages.admin.offers.legs.cryptoTopup';

export type OfferLegShortKey =
  | 'pages.admin.offers.legsShort.payin'
  | 'pages.admin.offers.legsShort.payout'
  | 'pages.admin.offers.legsShort.settlement'
  | 'pages.admin.offers.legsShort.cryptoTopup';

export const OFFER_LEG_I18N_KEY: Record<OfferLegKey, OfferLegLabelKey> = {
  crypto_topup: 'pages.admin.offers.legs.cryptoTopup',
  payin: 'pages.admin.offers.legs.payin',
  payout: 'pages.admin.offers.legs.payout',
  settlement: 'pages.admin.offers.legs.settlement',
};

export const OFFER_LEG_SHORT_I18N_KEY: Record<OfferLegKey, OfferLegShortKey> = {
  crypto_topup: 'pages.admin.offers.legsShort.cryptoTopup',
  payin: 'pages.admin.offers.legsShort.payin',
  payout: 'pages.admin.offers.legsShort.payout',
  settlement: 'pages.admin.offers.legsShort.settlement',
};

export const isOfferLegKey = (value: string): value is OfferLegKey =>
  (OFFER_LEG_KEYS as readonly string[]).includes(value);
